module.exports = "/_next/static/images/platform_4-1779c416a7c410ef416bdc3e270891de.png";